export const filters = [
    {
        label: "New to old",
        value: "new"
    },
    {
        label: "Old to new",
        value: "old"
    },
    {
        label: "All",
        value: "all"
    }
]


export const sortOptions = [
    {
        label: "All Types",
        value: "all"
    },
    {
        label: "Refill",
        value: "refill"
    },
    {
        label: "Appointment",
        value: "appointment"
    }  
]

export const statusOptions = [
    {
        label: "All",
        value: "all"
    },
    {
        label: "Resolved",
        value: "resolved"
    },
    {
        label: "Unresolved",
        value: "unresolved"
    },
    {
        label: "Action Needed",
        value: "action_needed"
    },
    {
        label: "Rejected",
        value: "rejected"
    },
    {
        label: "Fulfilled",
        value: "fulfilled"
    },
    {
        label: "Partially Fulfilled",
        value: "partially_fulfilled"
    },
]




export const dateFilters = [
    {
        label: "Today",
        value: "today"
    },
    {
        label: "This Week",
        value: "this_week"
    },
    {
        label: "This Month",
        value: "this_month"
    },
    {
        label: "This Year",
        value: "this_year"
    },
    
] 